<div class="modal-container">
  <div class="modal-container--text">
    <h5 class="modal-title alertTitle">{{ modalText }}</h5>
  </div>
  <div class="modal-container--btn-container">
    <button type="button" class="btn" (click)="closeModal()">
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
  </div>
</div>
